import { ErrorMessage } from "formik";
import React from "react";

const CustomError = ({ name }) => {
  return <ErrorMessage name={name} component="div" className="text-danger" />;
};

export default CustomError;
